// extracted by mini-css-extract-plugin
export default {"title":"PageTitleBlock_title__lcqLH","subtitle":"PageTitleBlock_subtitle__xEUJw"};